// import parser from 'fast-xml-parser'
import stockService from 'common/services/stockService'


class collectionExportService {
    constructor($http, $location, $q, logger, httpRequest, $rootScope, $state, $uibModal, sweetalert) {
        this.$http = $http
        this.$location = $location
        this.$q = $q
        this.logger = logger
        this.httpRequest = httpRequest
        this.$rootScope = $rootScope
        this.$state = $state
        this.$uibModal = $uibModal
        this.sweetalert = sweetalert
    }



    // 判断权限
    hasPermit(functionCode) {
        this.function_list = this.$rootScope.functionList
        if (!this.function_list) {
            this.function_list = JSON.parse(localStorage.getItem('function_list'))
        }
        const functionCodeArr = functionCode.split(',')
        let allow = false
        // 改造权限写法
        // @auther <sujingjun&&13682603870@163.com>
        if (!functionCodeArr.length) return allow
        for (const i in this.function_list) {
            if (functionCodeArr.indexOf(this.function_list[i].functionCode) > -1 && this.function_list[i].functionCode != 'have_a_look') {
                // have_a_look  查看按钮不显示,只为只读权限设置
                allow = true
                break
            }
        }
        return allow
    }

    // NOTE: 自动上报汇总
    /**
     *
     * @param {*} flag 自动汇总
     */
    async exportAutoCheck(disk) {

        // NOTE: 已开卡，且服务正常
        // NOTE: 金税盘和当前机构税号 相等
        // NOTE: 读取后台上报标记 -- 未上报 
        // NOTE: 锁死日期 >= 金税盘时间 >= 抄税起始日期 
        // NOTE: 调用上报接口
        // NOTE: 成功调用后修改状态


        const SsrqSet = [] //锁死日期
        const CsqsrqSet = [] //起始日期
        for (const key in disk.responseMsg.DATA) {
            disk.responseMsg.DATA[key].Ssrq && SsrqSet.push(parseInt(disk.responseMsg.DATA[key].Ssrq.slice(0, 8)))
            disk.responseMsg.DATA[key].Csqsrq && CsqsrqSet.push(parseInt(disk.responseMsg.DATA[key].Csqsrq.slice(0, 8)))
        }
        this.httpRequest.fetchDeclareSign({
            diskNo: disk.responseMsg.DATA.Jssbxx.Jspbh,
            type: 0,
        }).then(res => {
            if (res.data.value && res.data.value.status == '0' && Math.max.apply(null, SsrqSet) <= disk.responseMsg.DATA.Jssbxx.Jssbdqrq && disk.responseMsg.DATA.Jssbxx.Jssbdqrq < Math.min.apply(null, SsrqSet)) {
                //0700 自动上报
                this.useSoap('ewogICAgInBhcmFtIjogIjw/eG1sIHZlcnNpb249JzEuMCcgZW5jb2Rpbmc9XCJHQktcIj8_PEZQWFRfQ09NX0lOUFVUPjxJRD4wNzAwPC9JRD48REFUQT48L0RBVEE_PC9GUFhUX0NPTV9JTlBVVD4iCn0=').then((res) => {
                    console.log(res)
                    this.SID20Callback(res, 0, disk.responseMsg.DATA.Jssbxx.Jspbh)
                })

            }
        })
    }


    // NOTE: 自动清卡
    async autoExportClean(disk) {
        // NOTE: 判断权限
        const SsrqSet = [] //锁死日期
        let hasBszl = true //是否有报税资料
        for (const key in disk.responseMsg.DATA) {
            disk.responseMsg.DATA[key].Ssrq && SsrqSet.push(parseInt(disk.responseMsg.DATA[key].Ssrq.slice(0, 8)))
            disk.responseMsg.DATA[key].Bszl == '0' && (hasBszl = false)
        }
        this.httpRequest.fetchDeclareSign({
            diskNo: disk.responseMsg.DATA.Jssbxx.Jspbh,
            type: 1,
        }).then((res) => {
            if (res.data.value && res.data.value.status == '0' && Math.max.apply(null, SsrqSet) <= disk.responseMsg.DATA.Jssbxx.Jssbdqrq && hasBszl) {
                // 自动清卡操作 0701
                console.log('清卡0701')
                this.useSoap('ew0KICAgICJwYXJhbSI6ICI8P3htbCB2ZXJzaW9uPScxLjAnIGVuY29kaW5nPVwiR0JLXCI/PjxGUFhUX0NPTV9JTlBVVD48SUQ_MDcwMTwvSUQ_PERBVEE_PC9EQVRBPjwvRlBYVF9DT01fSU5QVVQ_Ig0KfQ==').then((res1) => {
                    console.log(res1)
                    // NOTE: 调用成功
                    this.SID20Callback(res, 1, disk.responseMsg.DATA.Jssbxx.Jspbh)
                })
            }
        })
    }


    // NOTE: auto
    exportAuto() {
        if (localStorage.soap && JSON.parse(localStorage.soap).status != 3) return
        if (!this.hasPermit('taxFilling.collection')) return
        const _that = this
        this.diskInfoFun().then(disk => {
            if (_that.checkPermit(disk) != 'success') return
            _that.exportAutoCheck(disk)
            _that.autoExportClean(disk)
        })
    }

    // 获取盘信息
    diskInfoFun() {
        return new Promise((resolve, rejects) => {

            stockService.getDiskInfo().then((disk) => {
                $.post({
                    url: `${window.location.origin}/etcloud/etcloud-sys/common/common/getJSONObject`,
                    dataType: 'json',
                    data: JSON.stringify({
                        data: disk
                    }),
                    contentType: 'application/json; charset=utf-8',
                    success(res) {
                        if (res.value.retcode == 0 && res.value.responseMsg.CODE == '0000') {
                            resolve(res.value)
                        } else if (res.value.retcode == 0) {
                            rejects(res.value.responseMsg.MESS)
                        } else {
                            rejects(res.value.retmsg)
                        }
                    }
                })
            }, () => {
                rejects('金税盘调用失败')
            })
        })
    }

    // 返回接入soap信息
    useSoap(paramStr) {
        let realUrl = REAL_URL.replace('8888', localStorage.soapPort)
        return new Promise((resolve, rejects) => {
            $.post({
                url: realUrl,
                data: {
                    SID: 20,
                    SIDParam: paramStr,
                },
                timeout: 30000,
            }).then((data) => {
                const DECMSG = JSON.parse(data).ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                    .replace(new RegExp(/(\r)/g), '')
                    .replace(new RegExp(/(\n)/g), '')
                this.httpRequest.post_base64DeCode({
                    invData: DECMSG,
                    codeType: 'decode',
                }).then((res) => {
                    resolve(JSON.parse(res.data.value))
                })
            }, () => {
                rejects()
            })
        })
    }


    // 抄报税之后的回调
    SID20Callback(res, isClean, diskNo) {

        const resStr = $($.parseXML(res.responseMsg))
        const param = {
            content: resStr.find('MESS').text(),
            code: resStr.find('CODE').text(),
            type: isClean ? 1 : 0,
            diskNo
        }
        console.log(param)
        return new Promise((resolve, rejects) => {

            this.httpRequest.updateDeclearSign(param).then(()=>{
                resolve(param.content)
            },()=>{
                rejects()
            })
        })
    }

    // 上报清卡前置条件
    checkPermit(disk) {
        const user_info = JSON.parse(localStorage.getItem('user_info'))
        if (disk.TaxCode != user_info.sale.saleCreditCode) return '金税盘和当前机构税号不一致'
        let hasUkey = 0
        user_info.sysUkeyList.forEach(item => {
            if (item.diskCode == disk.MachineNo) hasUkey++
        })
        if (hasUkey) {
            return 'success'
        } else {
            return '您没有当前开票点的的操作权限'
        }
    }
}
collectionExportService.$inject = ['$http', '$location', '$q', 'logger', 'httpRequest', '$rootScope', '$state', '$uibModal', 'sweetalert']
export default collectionExportService



// WEBPACK FOOTER //
// ./src/common/services/collectionExportService.js